export class UpdatePaymentProcessorModel {
    public paymentProcessorId: string;
    public countryIds :Array<number> =new Array<number>(); 
}
